<div class="tasks-container">
  <div class="header">
    <h1 class="header-text">Tasks</h1>
  </div>
  <div class="content">
    <div class="task-cards">
      @if (dataLoading()) {
        <app-loading-animation></app-loading-animation>
      }
      @if (dataEmpty()) {
        <div class="loaded no-data">No tasks available</div>
      }
      @if (dataAvailable()) {
        @for (task of tasks(); track task) {
          <div class="loaded task-card-wrapper">
            <div class="task-card">
              <div class="left">
                <div id="description-{{task.id}}" class="task-card-title">{{task.description}}</div>
                @if (task.percentageComplete > 0) {
                  <div class="task-progress">
                    @if (!task.readonly) {
                      <div class="value">{{task.percentageComplete}}% Complete</div>
                    }
                    @if (task.readonly) {
                      <div class="value">Completed</div>
                    }
                    <div class="bar">
                      <div class="bar-inner" [class.completed]="task.readonly" [style.width.%]="task.percentageComplete"></div>
                    </div>
                  </div>
                }
              </div>
              <div>
                <a class="task-card-button" [routerLink]="task.detailsRouterLinkCommands" [attr.aria-label]="task.detailsLabel + ' ' + task.description">
                  {{task.detailsLabel}}
                </a>
                <a class="task-card-icon" [routerLink]="task.detailsRouterLinkCommands" [attr.aria-label]="task.detailsLabel + ' ' + task.description">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <g>
                      <path d="M82.4,48.9C82.4,48.9,82.4,48.9,82.4,48.9l-15-14.8c-0.6-0.6-1.5-0.6-2.1,0c-0.6,0.6-0.6,1.5,0,2.1l12.4,12.3H18.6   c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h59.1L65.3,63.8c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4   l15-14.8c0,0,0,0,0,0l1.1-1.1L82.4,48.9z"/>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
